import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

import auth from './modules/auth';
import onboarding from './modules/onboarding';
import { RootState } from '@/store/types';

// create persistent storage
const persistent = new VuexPersistence<RootState>({
  storage: window.localStorage
});

Vue.use(Vuex);

Vue.config.devtools = (process.env.NODE_ENV && process.env.NODE_ENV === 'development') || true;

export default new Vuex.Store({
  modules: {
    onboarding,
    auth
  },
  plugins: [persistent.plugin]
});
